// extracted by mini-css-extract-plugin
export default {"imsLink":"IMSLink_imsLink__2MXH8"};